module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0006.jpg?v=279ad563";